module.exports = __webpack_public_path__ + "img/PodCell.27a6441f.png";